import MarkdownRender from 'LuxKit/MarkdownRender'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  title?: string
  content: string
}

function NotificationBannerV2Modal({ title, content }: Props) {
  const intl = useIntl()
  const { resolve } = useModalElementContext()

  const close = useCallback(() => {
    resolve()
  }, [resolve])

  return (
    <ModalBase height="full" tabletHeight="auto">
      {title && <ModalHeader title={title} />}
      <ModalBody>
        <ModalContent>
          <MarkdownRender content={content} />
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: intl.formatMessage({ id: 'TEzKljZr7qRMXUtSg8yA', defaultMessage: 'OK', description: 'Action button label to close the modal in the site header' }),
          onClick: close,
        }}
      />
    </ModalBase>
  )
}

export default NotificationBannerV2Modal
